var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone--android-phone-mobile-device-smartphone-iphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5124 13.1771C10.0442 13.5201 10.6779 13.6696 11.307 13.6005C11.9361 13.5312 12.5222 13.2476 12.9667 12.7971L13.3553 12.4171C13.5257 12.2428 13.6211 12.0088 13.6211 11.7652C13.6211 11.5215 13.5257 11.2874 13.3553 11.1132L11.7059 9.4811C11.5331 9.31129 11.3005 9.21613 11.0582 9.21613C10.8159 9.21613 10.5833 9.31129 10.4105 9.4811C10.2363 9.65147 10.0022 9.74686 9.75852 9.74686C9.51481 9.74686 9.28078 9.65147 9.10652 9.4811L6.51579 6.89049C6.42936 6.80532 6.36073 6.70382 6.31388 6.5919C6.26704 6.47998 6.24291 6.35985 6.24291 6.23852C6.24291 6.11718 6.26704 5.99706 6.31388 5.88513C6.36073 5.77321 6.42936 5.67171 6.51579 5.58654C6.68561 5.41375 6.78077 5.18117 6.78077 4.9389C6.78077 4.69662 6.68561 4.46404 6.51579 4.29124L4.875 2.65052C4.70071 2.48015 4.46671 2.38477 4.22302 2.38477C3.97924 2.38477 3.74524 2.48015 3.57095 2.65052L3.19096 3.03911C2.74053 3.4836 2.45686 4.06966 2.38763 4.69871C2.3184 5.32777 2.46793 5.96147 2.81106 6.49326C4.59868 9.12768 6.87325 11.3963 9.5124 13.1771Z",
    stroke: "#1D252D",
    strokeWidth: 0.865364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.9318796575a492b3fbfd5969341d2a41.svg";
export { ForwardRef as ReactComponent };